<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to offer grateful thanks to the following who have greatly assisted with the writing of this book. My wife Hilary encouraged me throughout the writing process. Keith and Avril Ravenscroft also gave much support and encouragement. Keith read the manuscript in stages as it was written and provided invaluable feedback – it kept me going! Keith, I can’t thank you enough. Susan Jones read the manuscript and made some thoughtful and helpful suggestions. Keith and Avril Ravenscroft, Richard Lawry, Ann Whitehead and more recently Val Hindmarsh, Patrick Angier and Sue Hawkins have all encouraged me to consider exploring the possibility of being published. Members of a number of local church congregations road tested this book and responded so positively to it. Lastly but not least the team at Austen Macauley Publishers worked hard to get this book to the finish line.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?65583db5